<template>
  <v-container class="agents" fluid>
    <div class="agents-header">
      <h1 class="agents-header__title">{{ $route.meta.title }}</h1>
      <div class="agents-header__actions">
        <v-btn
          v-if="$canRoute('NewAgent')"
          color="primary"
          class="agents-header__btn text-none"
          dark
          rounded
          to="/agents/new"
        >
          <v-icon left>mdi-plus</v-icon>
          Новый агент
        </v-btn>
      </div>
    </div>

    <v-card class="agents-block mt-3" flat outlined>
      <v-data-table
        class="table agents-table"
        :headers="headers"
        :items="agents"
        disable-sort
        :items-per-page="15"
        :footer-props="{
          'items-per-page-options': [10, 15, 20, 50],
          showFirstLastPage: true,
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-row justify="center" class="flex-nowrap">
            <v-tooltip v-if="$canRoute('EditAgent')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="btn__icon pa-0 mr-1"
                  width="18"
                  height="18"
                  :to="`/agents/edit/${item.id}`"
                >
                  <v-icon size="large">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Редактировать</span>
            </v-tooltip>
            <v-tooltip v-if="$can('destroy_agent')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="btn__icon pa-0"
                  width="18"
                  height="18"
                  @click.stop="$set(dialog, item.id, true)"
                >
                  <v-icon size="large">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>

            <v-dialog
              v-model="dialog[item.id]"
              persistent
              :retain-focus="false"
              max-width="350"
              content-class="dialog-border-radius"
            >
              <v-card class="agents-dialog">
                <v-card-title class="agents-dialog__title">Удалить организацию?</v-card-title>
                <v-card-text>Подтверждая, вы удалите организацию.</v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn text color="grey" @click="$set(dialog, item.id, false)">Отменить</v-btn>
                  <v-btn color="primary" :loading="loading" text @click.prevent="removeAgent(item.id)">Удалить</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              transition="dialog-top-transition"
              v-model="dialogWarning[item.id]"
              :retain-focus="false"
              max-width="420"
              content-class="dialog-border-radius"
            >
              <v-card>
                <v-card-title class="headline">Не удалось удалить агента.</v-card-title>
                <v-card-text>{{ updateResult.message }}</v-card-text>
                <v-card-text class="pb-2">Кол-во домофонов: {{ updateResult.doorphones_count }}</v-card-text>
                <v-card-text class="pb-2">Кол-во абонентов: {{ updateResult.abonents_count }}</v-card-text>
                <v-card-text class="pb-2">Кол-во ключей: {{ updateResult.keys_count }}</v-card-text>
                <v-card-text class="pb-2">Кол-во устройств: {{ updateResult.devices_count }}</v-card-text>
                <v-card-text>Кол-во менеджеров: {{ updateResult.managers_count }}</v-card-text>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Agents',
  data () {
    return {
      dialog: {},
      dialogWarning: {},
      loading: false,
      updateResult: [],
      headers: [
        {
          text: 'id',
          value: 'id',
        },
        {
          text: 'Организация',
          value: 'user.name',
        },
        {
          text: 'Юридический адрес',
          value: 'legal_address',
        },
        {
          text: 'Фактический адрес',
          value: 'actual_address',
        },
        {
          text: 'Контактное лицо',
          value: 'contact',
        },
        {
          text: 'Диспетчерская',
          value: 'dispatcher_phone',
        },
        {
          text: 'Телефон',
          value: 'telephone',
        },
        {
          text: 'Руководитель',
          value: 'supervisor',
        },
        {
          text: 'Email',
          value: 'user.email',
        },
        {
          text: '',
          value: 'actions',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      agents: 'Agents/agents',
    }),
  },
  methods: {
    ...mapActions({
      loadAllAgents: 'Agents/loadAllAgents',
      deleteAgent: 'Agents/deleteAgent',
    }),
    removeAgent (id) {
      this.loading = true;
      this.deleteAgent(id)
        .then(() => {
          this.$flash_success('Агент успешно удален');
          this.cancelDialogAgent(id);
        })
        .catch((err) => {
          this.$flash_danger('Не удалось удалить агента');
          this.updateResult = err.response.data;
          this.cancelDialogAgent(id);
          this.dialogWarning[id] = true;
        });
    },
    cancelDialogAgent (id) {
      this.dialog[id] = false;
      this.loading = false;
    },
  },
  created () {
    // this.loadAllAgents();
  },
};
</script>

<style lang="scss" scoped>
.agents-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.agents-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.agents-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.agents-header__btn {
  text-transform: none;
  font-weight: 500;
}

.agents-block {
  border-radius: 12px;
  overflow: hidden;
}

.agents-dialog__title {
  font-size: 1.1rem;
  font-weight: 600;
}

.v-card__text,
.v-card__title {
  word-break: normal;
}

@media screen and (max-width: 600px) {
  .agents-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .agents-header__title {
    font-size: 1.4rem;
  }
}
</style>
